import {
  PropType,
  computed,
  defineComponent,
  inject,
  onDeactivated,
  onMounted,
  ref,
} from 'vue';
import { Popup } from 'vant';
import router from '@/router/index.js';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { ModuleExposeOptions } from '~mall/common/directives/v-expose';
import { appQueryConfig } from '~mall/common/utils/url';
import { isEasyBikeApp } from '~mall/common/env/env';
import SlideNewPopUp from '../SlideNewPopUp/index.vue';
import TicketDetailNewPop from '../TicketDetailNewPop/index';
import { getStylesBinder } from '~mall/common/utils/styles';
import { showThirdPageOld } from '~mall/common/utils/jumpUrl';
// import { setParamsToUrl } from '~mall/common/utils/params';
// import { uiMgr } from '~mall/common/uiMgr';
import { SkuData } from '~mall/model/store/modules/ticket';
// import { RouterTicketDetail } from '~mall/constants/routerConstants';
import { onDetailPopupOpen, onDetailPopupClose } from '~mall/common/utils/widgetGuide';
import styles from './index.module.less';
import GoodListItemInfo from '../GoodListItemInfo';

const cx = getStylesBinder(styles);

export default defineComponent({
  name: 'GoodListItem',
  props: {
    skuData: {
      type: Object as PropType<SkuData>,
      required: true,
    },
    categoryName: {
      type: String,
      required: true,
    },
    tabCategoryName: {
      type: String,
      default: '',
    },
    categoryId: {
      type: String,
      required: true,
    },
    skuIndex: {
      type: Number,
      required: true,
    },
    // 超值精选标记
    highRecm: {
      type: Boolean,
      default: false,
    },
    listProps: {
      type: Object,
      default: () => ({}),
    },
    guessRecmGood: {
      type: Array,
      default: () => [],
    },
    traceId: {
      type: String,
      default: '',
    },
    /** 奖励金开关状态 */
    rewardSwitchOn: {
      type: Boolean,
      default: false,
    },
  },
  setup: (props) => {
    const styleVersion = inject('styleVersion');
    /** 是否展示高亮动画 */
    const showHighlightAnime = ref(false);
    /** 是否展示新半浮层 */
    const showNewPopup = ref(false);
    /** 是否高亮置顶 */
    const highlight = computed(
      () => !!props.skuData.highlight && props.skuIndex === 0,
    );
    /** UBT业务参数 */
    const sharedUbtBizInfo = computed(() => {
      const {
        skuData: {
          spuId,
          salePrice,
          originalPrice,
          activityInfo,
        },
        skuIndex,
        tabCategoryName,
      } = props;
      return {
        tabName: tabCategoryName,
        experimentalGroup: styleVersion,
        originalPrice: activityInfo?.salePrice ? salePrice : originalPrice,
        salePrice: activityInfo?.salePrice || salePrice,
        itemNo: skuIndex + 1,
        spuId,
        categoryid: props.categoryId,
        isSupervalue: props.highRecm,
        marketingLabel: props.skuData.marketingTagName,
        adsource: appQueryConfig.adsource,
        algoTraceID: props.traceId,
        sku_name: props.skuData.goodsName,
      };
    });
    /** 模块曝光选项 */
    const goodItemUbtExpose = computed<ModuleExposeOptions>(() => ({
      exposeData: {
        pageId: 'platform_couponmall',
        categoryId: 'platform',
        moduleId: 'platform_list_card',
        contentId: 'platform_list_card',
        exposureTimes: '1',
        businessInfo: sharedUbtBizInfo.value,
      },
    }));
    (() => {
      // * created() { //... }
      // UBT.moduleExpose({
      //   pageId: 'couponmall_list',
      //   categoryId: 'hellomall',
      //   moduleId: 'couponmall_list_card',
      //   contentId: 'couponmall_list_card',
      //   exposureTimes: 1,
      //   businessInfo: sharedUbtBizInfo.value,
      //   marketingLabel: marketingLabel.value,
      // });
    })();

    onMounted(() => {
      if (highlight.value) {
        const CACHE_KEY = 'highlight_anime_id';
        const cacheId = window.sessionStorage.getItem(CACHE_KEY);
        const { spuId } = props.skuData;

        if (cacheId === spuId) {
          return;
        }

        showHighlightAnime.value = true;
        window.setTimeout(() => {
          showHighlightAnime.value = false;
        }, 900);
        window.sessionStorage.setItem(CACHE_KEY, spuId);
      }
    });

    onDeactivated(() => {
      showNewPopup.value = false;
    });

    const handleClose = () => {
      showNewPopup.value = false;
      // 详情弹窗关闭，恢复小组件弹窗
      onDetailPopupClose();
    };
    const handleBuy = () => {
      if (props.skuData.collageGoods === 1 && props.skuData.collageLink) {
        showThirdPageOld(props.skuData.collageLink);
        return;
      }

      showNewPopup.value = true;
      // 详情弹窗打开，暂停小组件弹窗
      onDetailPopupOpen();
    };

    const renderTags = () => {
      //  展示优先级：秒杀活动-限时秒杀 > 特殊支付优惠 > 普通标签
      // 限时秒杀的活动优先展示
      if (props.skuData.effectiveActivityInfo) {
        return (
            <div class={cx('prod__tag-container')}>
              <div class={cx('prod__tag-kill', 'prod__tag-name')}>限时秒杀</div>
            </div>
        );
      }

      // 特殊支付
      if (isEasyBikeApp
          && props.skuData.specialPaymentId
          && props.skuData.promotionPaymentContent) {
        const content = props.skuData.promotionPaymentContent;

        return (
            <div class={cx('prod__tag-container')}>
              <div class={cx('prod__tag-special', 'prod__tag-name')}>{content}</div>
            </div>
        );
      }

      // 普通标签
      if (props.skuData.marketingTagName) {
        const content = props.skuData.marketingTagName;
        return (
            <div class={cx('prod__tag-container')}>
              <div class={cx('prod__tag-marketing', 'prod__tag-name')}>{content}</div>
            </div>
        );
      }
      return null;
    };

    return () => (
        <div>
          <div
            class={cx('prod', {
              'prod--highlight': highlight.value,
              'prod--highlight-anime': showHighlightAnime.value,
            })}
            v-node-expose={goodItemUbtExpose.value}
            onClick={() => {
              UBT.clickButton({
                pageId: 'platform_couponmall',
                buttonName: 'platform_list_card',
                categoryId: 'platform',
                businessInfo: sharedUbtBizInfo.value,
              });
              handleBuy();
            }}
          >
            { renderTags() }
            <div class={cx('prod__content')}>
              <div class={cx('prod__img-wrap', 'prod__img-wrap-new')}>
                <van-image
                  lazyLoad
                  class={cx('prod__img')}
                  src={props.skuData.listPicUrl}
                />
              </div>
              <GoodListItemInfo
                skuData={props.skuData}
                limitInfo={-1}
                highRecm={props.highRecm}
                handleBuy={handleBuy}
                rewardSwitchOn={props.rewardSwitchOn}
              />
            </div>
            {highlight.value && (
              <aside>
                <Popup
                  value={showHighlightAnime.value}
                  duration={0.1}
                  z-index={99}
                  overlay-style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
                  get-container="#app"
                />
              </aside>
            )}
          </div>
           <SlideNewPopUp
            show={showNewPopup.value}
            on-close={handleClose}
            on-click-overlay={handleClose}
            get-container="#app"
            componentParams={{
              ...router.app.$route.query,
              spuId: `${props.skuData.spuId}`,
              skuId: `${props.skuData.skuId}`,
              skuIndex: `${props.skuIndex}`,
              fromTabName: props.categoryName,
              isFromList: '1',
              algorithmPriceFlag: props.skuData.algorithmPriceFlag,
            }}
            scopedSlots={{
              content: ({
                fullScreen,
                getRef,
              }: {
                fullScreen: boolean;
                getRef: (el: HTMLElement) => void;
                height: string;
                transform: string;
                transition: string;
              }) => (
                showNewPopup.value && (
                  <TicketDetailNewPop
                    query={{
                      ...router.app.$route.query,
                      spuId: `${props.skuData.spuId}`,
                      skuIndex: `${props.skuIndex}`,
                      fromTabName: props.categoryName,
                      categoryId: props.categoryId,
                      isFromList: '1',
                      algorithmPriceFlag: props.skuData.algorithmPriceFlag,
                      highRecm: props.highRecm,
                    }}
                    full-screen={fullScreen}
                    get-ref={getRef}
                  />
                )
              ),
            }}
          />

        </div>
    );
  },
});
